interface Props {
  userId: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function UserAuditPanel(_props: Props) {
  return (
    <div className="space-y-4 max-w-2xl">
      <div className="p-4 border border-mp-border rounded bg-mp-background text-mp-muted text-sm">
        Audit history for this user will be available when the audit-service consumer endpoint is configured. (Deferred per plan.)
      </div>
    </div>
  );
}
